import { GIT_PROVIDERS } from 'common/constants/constants';
import _ from 'lodash';

export const getRepoFullName = repo => {
  const repoName = repo.name;
  const repoUrl = repo.http_url;
  const isAzureDevOps = repo.sensor_id === GIT_PROVIDERS.AZURE_DEVOPS;
  try {
    const url = new URL(isAzureDevOps ? repoUrl.replace('/_git', '') : repoUrl);
    const pathname = _.get(url, 'pathname', '');
    const urlSections = pathname.split('/');
    const relevantSection = urlSections[urlSections.length - 2];
    return _.size(urlSections) > 3
      ? `${relevantSection}/${repoName}`
      : repoName;
  } catch (e) {
    return repoName;
  }
};
